import { NavLink, Outlet } from 'react-router-dom';

const settingsNavItems = [
  {
    path: '/settings/profile',
    label: '个人资料设置',
    description: '更新用户名和邮箱',
  },
  {
    path: '/settings/llm-providers',
    label: 'LLM 设置',
    description: '管理 provider 和模型',
  },
];

export default function SettingsPage() {
  return (
    <div className="max-w-[1180px] mx-auto px-6 py-12 space-y-6">
      <div>
        <h1 className="font-semibold text-apple-near-black text-[2rem] leading-tight tracking-tight">
          设置
        </h1>
        <p className="text-apple-gray text-[0.9375rem] mt-1">集中管理账户资料和生成服务配置。</p>
      </div>

      <nav className="grid grid-cols-1 sm:grid-cols-2 gap-3" aria-label="设置导航">
        {settingsNavItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            aria-label={item.label}
            className={({ isActive }) =>
              `rounded-xl border px-4 py-3 transition-colors ${
                isActive
                  ? 'border-apple-blue bg-[#e8f4ff] text-apple-near-black'
                  : 'border-apple-border bg-white text-apple-near-black hover:border-apple-blue/40'
              }`
            }
          >
            <span className="block text-[0.9375rem] font-medium">{item.label}</span>
            <span className="mt-1 block text-[0.8125rem] text-apple-gray">{item.description}</span>
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
